/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const ID = feature.getSettingValue('NAME');
    const FIELDTYPE = feature.getSettingValue('FIELDTYPE');
    let P1 = feature.getSettingValue('P1');
    let P2 = feature.getSettingValue('P2');
    let DEFAULT = feature.getSettingValue('DEFAULT');
    if (DEFAULT === '') {
        DEFAULT = '^';
    }
    let DISPLAY_NAME = feature.getSettingValue('DISPLAY_NAME');
    if (DISPLAY_NAME === '') {
        DISPLAY_NAME = ID;
    }
    if (FIELDTYPE === 'T') {
        P1 = feature.getSettingValue('FORMAT');
        P2 = '0';
    }
    blocks.push({
        location: 'tables.xtxt',
        blockType: BlockType.CODE,
        template: `>>${ID}\t${FIELDTYPE}\t${P1}\t${P2}\t${DEFAULT}\t${DISPLAY_NAME}`,
    });
    return blocks;
};
